import { ContentfulMagnetPage } from "@outschool/gql-backend-generated";
import { CSSProperties } from "@styled-system/css";
import React from "react";

import SimilarArticlesMagnetPageCarousel from "./SimilarArticlesMagnetPageCarousel";

export default function MagnetPagesCarousel({
  articles,
  carouselSx,
  isSSR,
}: {
  articles: ContentfulMagnetPage[];
  carouselSx?: CSSProperties;
  isSSR?: boolean;
}) {
  return (
    <SimilarArticlesMagnetPageCarousel
      articles={articles}
      carouselSx={carouselSx}
      isSSR={isSSR}
    />
  );
}
